(() => {
const motion = matchMedia('(prefers-reduced-motion: reduce)');
const hover = matchMedia('(hover: hover)');
function setup(root=document) {
root.querySelectorAll('a.header-logo:not(.tl-ready), .tl-footer-lockup:not(.tl-ready)').forEach(logo => {
const svg=logo.querySelector(':scope > .talamora-compass');
if(!svg) return;
const walker=document.createTreeWalker(logo,NodeFilter.SHOW_TEXT);
const nodes=[]; let node;
while(node=walker.nextNode()) if(node.textContent.trim()==='TALAMORA') nodes.push(node);
if(!nodes.length) return;
logo.setAttribute('aria-label','TALAMORA');
nodes.forEach(text => {
const wrapper=document.createElement('span'); wrapper.setAttribute('aria-hidden','true');
[...text.textContent.trim()].forEach((letter,i)=>{const span=document.createElement('span');span.className='tl-letter';span.style.setProperty('--tl-index',i);span.textContent=letter;wrapper.append(span)});
text.replaceWith(wrapper);
});
const rotor=document.createElementNS('http://www.w3.org/2000/svg','g');rotor.classList.add('tl-rotor');
while(svg.firstChild) rotor.append(svg.firstChild);svg.append(rotor);
logo.classList.add('tl-ready');
let playing=false, finish, timer;
function schedule(){clearTimeout(timer);timer=setTimeout(play,60000)}
function play(){
if(!logo.isConnected){clearTimeout(timer);return}
if(playing) return;
const bounds=logo.getBoundingClientRect();
if(motion.matches||document.hidden||bounds.bottom<0||bounds.top>innerHeight||bounds.width===0){schedule();return}
playing=true;logo.classList.add('tl-playing');
clearTimeout(timer);
finish=setTimeout(()=>{logo.classList.remove('tl-playing');playing=false},4550);
schedule();
}
logo.addEventListener('pointerenter',()=>{if(hover.matches)play()});
motion.addEventListener('change',()=>{if(motion.matches){clearTimeout(finish);logo.classList.remove('tl-playing');playing=false}});
if(logo.classList.contains('tl-footer-lockup')){
const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){play();observer.disconnect()}},{threshold:.35});
observer.observe(logo);
}else{requestAnimationFrame(play);}
});
}
setup();
document.addEventListener('shopify:section:load',e=>setup(e.target));
})();